import React from 'react';
import PropTypes from 'prop-types';
import { useApolloClient, gql } from '@apollo/client';
import { Typeahead } from '@administrate/piston-ux';
import { withTranslation } from 'react-i18next';
import { extractNodes } from './pickerHelpers';

const GET_LEARNING_PATHS = gql`
  query getLearningPaths(
    $filters: [LearningPathFieldFilter!]!
    $order: LearningPathFieldOrder!
  ) {
    learningPaths(filters: $filters, order: $order) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const LearningPathPicker = ({ t, name, required, valid, onChange }) => {
  const client = useApolloClient();

  const loadOptions = async inputValue => {
    const { data } = await client.query({
      query: GET_LEARNING_PATHS,
      variables: {
        filters: [
          {
            field: 'name',
            operation: 'like',
            value: `%${inputValue}%`,
          },
        ],
        order: {
          field: 'name',
          direction: 'asc',
        },
      },
    });

    return extractNodes(data?.learningPaths);
  };

  return (
    <Typeahead
      name={name}
      label={t('builder:path')}
      required={required}
      loadOptions={loadOptions}
      formatter={learningPath => learningPath.name}
      staticFormatter={learningPath => learningPath.name}
      valid={valid}
      onChange={onChange}
      isClearable={!required}
    />
  );
};

LearningPathPicker.defaultProps = {
  required: false,
  valid: undefined,
};

LearningPathPicker.propTypes = {
  t: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  valid: PropTypes.func,
};

export default withTranslation()(LearningPathPicker);
